module.exports = __webpack_public_path__ + "static/media/aqua-lose.c2c90799.png";